export const comicCategories = [
  "全部",
  "玄幻",
  "都市",
  "恋爱",
  "科幻",
  "武侠",
  "悬疑",
  "国风",
  "热血",
  "日常",
];

export const comics = [
  {
    id: "xingchen-jiange",
    title: "星辰剑歌",
    author: "墨白",
    category: "玄幻",
    tags: ["热血", "升级流", "剑修"],
    latestChapter: "第 428 话 · 星海封剑",
    status: "连载中",
    badge: "本周人气",
    reads: "1.2 亿",
    description:
      "少年林昭背负灭门之仇，于星陨之夜觉醒古剑意。他一步步踏入宗门、秘境与星海战场，只为在漫天星辰之下问一句——剑道尽头，究竟有没有答案。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20manga%20style%20illustration%20of%20a%20young%20swordsman%20holding%20a%20glowing%20star%20sword%20under%20a%20starry%20night%20sky%2C%20warm%20orange%20and%20gold%20color%20palette%2C%20dramatic%20rim%20lighting%2C%20detailed%20comic%20book%20cover%20art%2C%20clean%20simple%20background%2C%20high%20detail&width=600&height=800&seq=baozi-comic-01&orientation=portrait",
  },
  {
    id: "dushi-lieren",
    title: "都市猎人",
    author: "陈四",
    category: "都市",
    tags: ["悬疑", "异能", "都市"],
    latestChapter: "第 301 话 · 天台交易",
    status: "连载中",
    badge: "编辑推荐",
    reads: "8600 万",
    description:
      "白天他是普通的外卖骑手，夜里他是替委托人解决“麻烦”的都市猎人。当一单看似寻常的委托牵扯出旧城改造背后的秘密，他发现自己也早已被写进了名单。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20stylish%20detective%20standing%20on%20a%20modern%20city%20rooftop%20at%20dusk%2C%20warm%20amber%20and%20deep%20crimson%20accents%2C%20cinematic%20comic%20book%20cover%2C%20dynamic%20pose%2C%20simple%20clean%20background%2C%20high%20detail&width=600&height=800&seq=baozi-comic-02&orientation=portrait",
  },
  {
    id: "xiaoyuan-lianyu",
    title: "校园恋语",
    author: "柚子酱",
    category: "恋爱",
    tags: ["甜宠", "青春", "校园"],
    latestChapter: "第 176 话 · 毕业钟声",
    status: "连载中",
    reads: "7400 万",
    description:
      "转学生的第一天就坐错了桌，也坐进了一整段青春。收作业的便利贴、雨天的同一把伞、运动会看台上的方向——那些没说出口的话，都被画进了这一页页分镜里。",
    cover:
      "https://readdy.ai/api/search-image?query=soft%20anime%20style%20illustration%20of%20two%20high%20school%20students%20under%20a%20cherry%20blossom%20tree%2C%20warm%20pastel%20pink%20and%20cream%20tones%2C%20gentle%20romantic%20mood%2C%20detailed%20manga%20cover%20art%2C%20clean%20simple%20background%2C%20high%20detail&width=600&height=800&seq=baozi-comic-03&orientation=portrait",
  },
  {
    id: "lingyu-xingzhe",
    title: "灵域行者",
    author: "青鹤",
    category: "玄幻",
    tags: ["修真", "群像", "世界观"],
    latestChapter: "第 512 话 · 归墟之门",
    status: "连载中",
    badge: "口碑佳作",
    reads: "1.5 亿",
    description:
      "天地灵气枯竭三百年后，第一批“行者”走入了被称为灵域的裂缝。他们带回力量，也带回禁忌。当少年阿九推开归墟之门，整个世界的秩序开始重新排列。",
    cover:
      "https://readdy.ai/api/search-image?query=epic%20anime%20style%20illustration%20of%20a%20mystic%20cultivator%20surrounded%20by%20floating%20glowing%20runes%2C%20warm%20gold%20and%20crimson%20palette%2C%20fantasy%20comic%20cover%2C%20atmospheric%20lighting%2C%20simple%20background%2C%20highly%20detailed&width=600&height=800&seq=baozi-comic-04&orientation=portrait",
  },
  {
    id: "jixie-jiyuan",
    title: "机械纪元",
    author: "零号工坊",
    category: "科幻",
    tags: ["机甲", "末世", "硬核"],
    latestChapter: "第 233 话 · 最后一台主机",
    status: "连载中",
    reads: "6200 万",
    description:
      "人类退守地下城的第七十年，最后一台能独立作战的机甲被重新唤醒。驾驶舱里的少年不知道，他要面对的不只是废墟上的怪物，还有人类自己留下的答案。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20mecha%20illustration%20of%20a%20giant%20robot%20standing%20in%20a%20futuristic%20ruined%20city%2C%20warm%20sunset%20light%2C%20orange%20and%20steel%20gray%20tones%2C%20sci-fi%20comic%20book%20cover%2C%20dynamic%20composition%2C%20simple%20background%2C%20high%20detail&width=600&height=800&seq=baozi-comic-05&orientation=portrait",
  },
  {
    id: "jianghu-yeyu",
    title: "江湖夜雨",
    author: "半盏灯",
    category: "武侠",
    tags: ["国风", "复仇", "江湖"],
    latestChapter: "第 189 话 · 十年一诺",
    status: "连载中",
    reads: "5800 万",
    description:
      "一把旧刀、一壶浊酒、一场下了十年的夜雨。他重回江湖只为赴一个约定，却发现当年的人早已散落天涯，只留下客栈墙上半句没写完的诗。",
    cover:
      "https://readdy.ai/api/search-image?query=traditional%20Chinese%20wuxia%20anime%20illustration%20of%20a%20lone%20swordsman%20standing%20in%20a%20bamboo%20forest%20on%20a%20rainy%20night%2C%20warm%20lantern%20light%2C%20ink%20wash%20style%20comic%20cover%2C%20atmospheric%2C%20simple%20background%2C%20highly%20detailed&width=600&height=800&seq=baozi-comic-06&orientation=portrait",
  },
  {
    id: "tianmi-bianlidian",
    title: "甜蜜便利店",
    author: "晚安猫",
    category: "日常",
    tags: ["治愈", "美食", "轻松"],
    latestChapter: "第 264 话 · 深夜关东煮",
    status: "连载中",
    badge: "治愈系",
    reads: "4300 万",
    description:
      "凌晨两点还亮着灯的便利店，会遇见加班的人、吵架的人、和不敢回家的人。收银台后的店长从不追问，只是把热好的饭团推过去，说一句“小心烫”。",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20anime%20illustration%20of%20a%20small%20convenience%20store%20with%20warm%20lights%20at%20night%2C%20gentle%20slice%20of%20life%20mood%2C%20warm%20amber%20palette%2C%20manga%20cover%20art%2C%20simple%20clean%20background%2C%20high%20detail&width=600&height=800&seq=baozi-comic-07&orientation=portrait",
  },
  {
    id: "shenyuan-diaochaju",
    title: "深渊调查局",
    author: "灰鸦",
    category: "悬疑",
    tags: ["惊悚", "推理", "团队"],
    latestChapter: "第 158 话 · 第七层回音",
    status: "连载中",
    reads: "5100 万",
    description:
      "凡是无法解释的失踪案，最后都会转到这个没有招牌的部门。四名调查员带着不同的目的进入地下遗迹，他们记录下的每一段文字，都可能是下一个人的遗言。",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20anime%20illustration%20of%20investigators%20with%20lanterns%20descending%20into%20an%20ancient%20underground%20ruin%2C%20warm%20torch%20light%20against%20deep%20shadows%2C%20mystery%20comic%20cover%2C%20simple%20background%2C%20highly%20detailed&width=600&height=800&seq=baozi-comic-08&orientation=portrait",
  },
  {
    id: "shanhai-yiwenlu",
    title: "山海异闻录",
    author: "鹿鸣",
    category: "国风",
    tags: ["神话", "志怪", "考据"],
    latestChapter: "第 142 话 · 青丘之约",
    status: "连载中",
    reads: "6900 万",
    description:
      "以《山海经》为骨、以民间志怪为肉，一册书记录了那些被时间遗忘的生灵。画风取古卷设色，每一话都像展开一幅会动的长卷。",
    cover:
      "https://readdy.ai/api/search-image?query=Chinese%20national%20style%20illustration%20inspired%20by%20classic%20mythology%20creatures%2C%20warm%20red%20and%20gold%20palette%2C%20ornate%20ancient%20scroll%20aesthetic%2C%20comic%20cover%2C%20simple%20background%2C%20highly%20detailed&width=600&height=800&seq=baozi-comic-09&orientation=portrait",
  },
  {
    id: "rexue-qingtangmian",
    title: "热血清汤面",
    author: "老张头",
    category: "热血",
    tags: ["竞技", "美食", "成长"],
    latestChapter: "第 210 话 · 决赛前夜",
    status: "连载中",
    reads: "4700 万",
    description:
      "一碗清汤面，从街边小摊一路做进全国大赛。少年的锅里只有汤和面，却要煮出所有人的期待。输赢之外，他想知道的是——好吃，究竟有没有标准答案。",
    cover:
      "https://readdy.ai/api/search-image?query=energetic%20anime%20illustration%20of%20a%20young%20chef%20serving%20steaming%20noodles%20with%20fiery%20determination%2C%20warm%20orange%20tones%2C%20dynamic%20shonen%20comic%20cover%20art%2C%20simple%20clean%20background%2C%20high%20detail&width=600&height=800&seq=baozi-comic-10&orientation=portrait",
  },
];

export const ranking = [
  { rank: 1, title: "灵域行者", author: "青鹤", category: "玄幻", reads: "1.5 亿", trend: "up" },
  { rank: 2, title: "星辰剑歌", author: "墨白", category: "玄幻", reads: "1.2 亿", trend: "flat" },
  { rank: 3, title: "都市猎人", author: "陈四", category: "都市", reads: "8600 万", trend: "up" },
  { rank: 4, title: "校园恋语", author: "柚子酱", category: "恋爱", reads: "7400 万", trend: "down" },
  { rank: 5, title: "山海异闻录", author: "鹿鸣", category: "国风", reads: "6900 万", trend: "up" },
  { rank: 6, title: "机械纪元", author: "零号工坊", category: "科幻", reads: "6200 万", trend: "flat" },
];